import {
    useContext,
    createContext,
} from 'react'

export type LongTermLeaseInvoicePositionContextType = {
    longTermLeaseInvoiceId: number
}

export const LongTermLeaseInvoicePositionContext = createContext<
    LongTermLeaseInvoicePositionContextType>(null)

const useLongTermLeaseInvoicePositionContext = () => {
    return useContext<LongTermLeaseInvoicePositionContextType>(LongTermLeaseInvoicePositionContext)
}

export default useLongTermLeaseInvoicePositionContext
